import script from "./fileUploader.vue?vue&type=script&setup=true&lang=js"
export * from "./fileUploader.vue?vue&type=script&setup=true&lang=js"

import "./fileUploader.vue?vue&type=style&index=0&id=0ea981bd&lang=scss"

const __exports__ = script;

export default __exports__